import Stack from '@mui/material/Stack';
import type { GetBidderCreativeQuery } from '../../../graphql/query/creatives/GetBidderCreative.generated.tsx';
import type { AdvertiserOption, ContentCategoryOption } from '../types.ts';
import { CreativeContentDetailsSection } from './sections/CreativeContentDetailsSection.tsx';
import { CreativeContentSection } from './sections/CreativeContentSection.tsx';
import { CreativeDetailsSection } from './sections/CreativeDetailsSection.tsx';

type CreativeDetailsTabProps = {
  creative: NonNullable<GetBidderCreativeQuery['bidderCreativeById']>;
  advertiserOptions: AdvertiserOption[];
  iabCategoryOptions: ContentCategoryOption[];
};

export const CreativeDetailsTab = ({ creative, advertiserOptions, iabCategoryOptions }: CreativeDetailsTabProps) => {
  return (
    <Stack direction="column">
      <CreativeDetailsSection creative={creative} advertiserOptions={advertiserOptions} />
      <CreativeContentSection creative={creative} />
      <CreativeContentDetailsSection creative={creative} iabCategoryOptions={iabCategoryOptions} />
    </Stack>
  );
};
